import React from 'react';
import {
  MeasuredCookieType,
  measuredDefaultSize,
  MeasuredInjectedProps,
  MeasuredContainer,
} from '@wix/da-shared-react/pkg/Measured';
import { Pages } from '../../../constants';
import { TopNecoStrip } from '../../../types/api';
import TopTopics from '../TopTopics';
import StripWrapper from './StripWrapper';

export interface Props {
  strip: TopNecoStrip;
  page?: Pages;
  className?: string;
}

export const TopicStrip: React.FC<Props> = props => {
  const { strip, page, className } = props;

  return (
    <StripWrapper strip={strip} page={page!} className={className}>
      <MeasuredContainer
        cookieType={MeasuredCookieType.TOPICS_STRIP}
        cookieDim="width"
        defaultSize={measuredDefaultSize}
        limitToParentWidth
        listenOnWindow
      >
        {(measuredProps: MeasuredInjectedProps) => {
          const availableWidth = measuredProps.container
            ? measuredProps.container.width
            : measuredDefaultSize.desktop.width;
          return (
            <div ref={measuredProps.onRef}>
              <TopTopics
                topTopics={strip.topNecos}
                availableWidth={availableWidth}
              />
            </div>
          );
        }}
      </MeasuredContainer>
    </StripWrapper>
  );
};
TopicStrip.displayName = 'TopicStrip';

export default TopicStrip;
